import classnames from "classnames";
import PropTypes from "prop-types";
import { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Label from "shared/components/Label";
import {
  DEFAULT_EMAIL_RICH_TEXT_FORMATS,
  DEFAULT_EMAIL_RICH_TEXT_TOOLBAR,
} from "utils/constants/richTextEditor";
import "utils/quill/registerEmailQuillFormats";

const LAYOUT = {
  FORM: "form",
  EMBED: "embed",
};

const RichText = ({
  label,
  value,
  onChange,
  placeholder,
  toolbarOptions,
  formats,
  readOnly,
  className,
  fieldClassName,
  layout,
  theme,
  errors,
  touched,
}) => {
  const modules = useMemo(
    () => ({ toolbar: toolbarOptions }),
    [toolbarOptions],
  );

  const quill = (
    <ReactQuill
      theme={theme}
      value={value || ""}
      onChange={onChange}
      modules={modules}
      formats={formats}
      readOnly={readOnly}
      placeholder={placeholder}
      className={classnames(
        { "input--borderd--red": touched && errors },
        fieldClassName,
      )}
    />
  );

  if (layout === LAYOUT.EMBED) {
    return (
      <div className={className}>
        {quill}
        {touched && errors ? <p className="input--errors">{errors}</p> : null}
      </div>
    );
  }

  return (
    <div
      className={classnames("input__wrapper rich-text-input", className, {
        __error: touched && errors,
      })}
    >
      <Label label={label} />
      <div className="rich-text-input__field">{quill}</div>
      {touched && errors ? <p className="input--errors">{errors}</p> : null}
    </div>
  );
};

RichText.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  toolbarOptions: PropTypes.array,
  formats: PropTypes.arrayOf(PropTypes.string),
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  fieldClassName: PropTypes.string,
  layout: PropTypes.oneOf(Object.values(LAYOUT)),
  theme: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  touched: PropTypes.bool,
};

RichText.defaultProps = {
  label: "",
  value: "",
  placeholder: "",
  toolbarOptions: DEFAULT_EMAIL_RICH_TEXT_TOOLBAR,
  formats: DEFAULT_EMAIL_RICH_TEXT_FORMATS,
  readOnly: false,
  className: "",
  fieldClassName: "",
  layout: LAYOUT.FORM,
  theme: "snow",
  errors: undefined,
  touched: false,
};

export { LAYOUT as RICH_TEXT_LAYOUT };
export default RichText;
